import { useI18n } from '@alife/panda-i18n';
import React, { useEffect, useMemo, useRef } from 'react';
import { useSetState } from 'ahooks';
import { searchHotKnowledge } from 'src/services';
import { PanelType } from 'src/types';
import { logCustom } from 'src/utils/tracker';
import Loading from 'src/view/components/loading';
import Result from 'src/view/components/result';
import SearchInput from 'src/view/components/search-input';
import Header from '../header';
import HighlightContent from './components/highlight-content';
import './index.scss';
let id = 0;
export default function HotKnowledgeSearch(props) {
    const { onBack, panelCode, data, keyword, list } = props;
    const $i18n = useI18n();
    const [state, setState] = useSetState({
        loading: false,
        keyword: keyword || '',
        resultList: list || []
    });
    const keywordRef = useRef('');
    keywordRef.current = state.keyword;
    const onSearch = (title) => {
        // console.log('ttt', title);
        if (!title) {
            setState({
                keyword: title,
                loading: false,
                resultList: []
            });
            return;
        }
        ;
        const tempId = ++id;
        setState({
            keyword: title,
            loading: true,
        });
        searchHotKnowledge({
            panelCode,
            title,
            language: $i18n.getLang()
        }).then(res => {
            // 过滤多余请求
            if (tempId < id || keywordRef.current !== title)
                return;
            props?.onItemClick?.(PanelType.hotQuestionSearch, { keyword: title, list: res });
            setState({
                loading: false,
                resultList: res
            });
        }).catch(() => {
            setState({
                loading: false,
            });
        }).finally(() => {
            setState({});
        });
    };
    useEffect(() => {
        logCustom('EXP_SearchHotQuestion', data, panelCode);
    }, []);
    const keywords = useMemo(() => state.keyword ? [state.keyword] : [], [state.keyword]);
    // console.log('state.keyword', state.keyword);
    return (React.createElement("div", { className: `cn-ui-intelli-assistant-hot-knowledge-search`, style: props.style },
        React.createElement(Header, { onClick: onBack, title: $i18n.get({ id: 'Search', dm: '搜索' }) }),
        React.createElement("div", { className: "cn-ui-intelli-assistant-hot-knowledge-search-body" },
            React.createElement(SearchInput, { autoFocus: true, onChange: onSearch, defaultValue: state.keyword, hasClear: true }),
            React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-knowledge-search-body-content' }, !state.keyword
                ? React.createElement(Result, { icon: 'https://img.alicdn.com/imgextra/i4/O1CN01HgY7B322WfxE3IGen_!!6000000007128-2-tps-300-240.png', title: "  ", subTitle: $i18n.get({ id: 'PleaseEnterTheQuestionKeywordSearch_1848556372', dm: '请输入问题关键词搜索' }) })
                : state.loading
                    ? React.createElement(Loading, { visible: true })
                    : state.resultList?.length
                        ? React.createElement(React.Fragment, null,
                            React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-knowledge-search-body-content-hint' },
                                $i18n.get({ id: 'SearchForRelevantContentForYou_171936019', dm: '为您搜索到相关内容' }),
                                ":"),
                            state.resultList.map(item => {
                                return React.createElement("div", { className: 'cn-ui-intelli-assistant-hot-knowledge-search-body-content-item', key: item.id, onClick: async () => {
                                        // const data = await getDetail({ questionId: (item.id) as unknown as string });
                                        props?.onItemClick?.(PanelType.hotQuestion, item.id);
                                        logCustom(`CLK_${PanelType.hotQuestion}`, item.id, props.panelCode);
                                        // onBack();
                                    } },
                                    React.createElement(HighlightContent, { content: item.title, keywords: keywords }));
                            }))
                        : React.createElement(Result, { type: "empty", title: $i18n.get({ id: 'NoSearchResultsForTheTime_552549461', dm: '暂无搜索结果' }), subTitle: $i18n.get({ id: 'TryAnotherWordAndTryAgain_2018653936', dm: '尝试换个词再试试吧' }) })))));
}
